import { Observable } from 'rxjs';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { AccountObjectFacade } from '../account-object/account-object.facade';
import { AccountStatisticsApiFacade } from './account-statistics.api-facade';
import { AccountStatistics } from './account-statistics.model';
import { AccountStatisticsStoreFacade } from './account-statistics.store-facade';

export class AccountStatisticsFacade extends AccountObjectFacade<AccountStatistics, AccountStatisticsApiFacade, AccountStatisticsStoreFacade> {

    protected syncAllByAccount(accountId: string, options?: ApiRequestOptions): Observable<any> {
        return this.api.getAll(accountId, options)
            .do(statistics => {
                statistics.forEach(stat => {
                    this.store.insert(stat);
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.facade.ts